import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../pages-styles/project-consultancy.css';
import { usePageMeta } from '../hooks/usePageMeta';

export default function MarketResearch() {
  usePageMeta(
    'Market Research & Feasibility - Magbity Agency Ltd',
    'Comprehensive market research, feasibility studies, project planning, and evaluation services.'
  );

  useEffect(() => {
    const el = document.querySelector('.market-3d-card');
    if (el) el.classList.add('enter');
  }, []);

  return (
    <div className="project-consultancy">
      <section className="consultancy-hero-banner market-hero">
        <div className="consultancy-hero-overlay"></div>
        <div className="consultancy-hero-content">
          <div className="consultancy-hero-text">
            <h1>Market Research & Feasibility</h1>
            <p>
              Data-driven market research and comprehensive feasibility studies to assess opportunity, 
              competition, risks, and sustainability. We help you make informed strategic decisions before 
              investing time and resources.
            </p>
          </div>

          <div className="market-illustration">
            <div className="market-3d-scene">
              <div className="market-3d-card">
                <div className="face front">
                  <svg width="220" height="220" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="marketGrad" x1="0" x2="1">
                        <stop offset="0%" stopColor="#16c784" />
                        <stop offset="100%" stopColor="#00d4ff" />
                      </linearGradient>
                    </defs>
                    <rect x="10" y="10" width="200" height="200" rx="16" fill="url(#marketGrad)" opacity="0.12" />
                    <g transform="translate(35,35) scale(0.9)">
                      <rect x="15" y="10" width="60" height="8" rx="3" fill="#fff" opacity="0.14" />
                      <rect x="10" y="30" width="70" height="12" rx="4" fill="#fff" opacity="0.12" />
                      <circle cx="35" cy="60" r="16" fill="#fff" opacity="0.1" />
                      <rect x="15" y="85" width="50" height="6" rx="3" fill="#fff" opacity="0.08" />
                    </g>
                  </svg>
                  <div className="card-label">Market Insights</div>
                </div>
                <div className="face back">
                  <h4>Research Outcomes</h4>
                  <p>Market analysis, feasibility reports, risk assessment and actionable recommendations.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="consultancy-services market-details">
        <h2>Market Research Services</h2>
        <div className="services-list">
          <div className="service-item left">
            <div className="service-content">
              <h3>Market Analysis & Opportunity Assessment</h3>
              <p>
                We conduct primary and secondary research to identify market demand, growth potential, 
                emerging trends, and competitive positioning. Data-driven insights inform strategic decisions.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 19h4v-5h2v5h4V9H2v10zm6-12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" opacity=".2"/>
                <path d="M2 19h4v-5h2v5h4V9H2v10zm6-12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
              </svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4 4h2v14h-2zm4-4h2v18h-2z" opacity=".2"/>
                <path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4 4h2v14h-2zm4-4h2v18h-2z"/>
              </svg>
            </div>
            <div className="service-content">
              <h3>Feasibility Studies & Risk Assessment</h3>
              <p>
                Comprehensive feasibility analysis evaluating technical, financial, operational and 
                market viability. We identify risks, mitigation strategies, and critical success factors.
              </p>
            </div>
          </div>

          <div className="service-item left">
            <div className="service-content">
              <h3>Competitive Landscape Analysis</h3>
              <p>
                In-depth competitor research, market positioning analysis, and strategic differentiation 
                opportunities to help you stand out and capture market share.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" opacity=".2"/>
                <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" opacity=".2"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
              </svg>
            </div>
            <div className="service-content">
              <h3>Stakeholder & Sector Research</h3>
              <p>
                Interviews, surveys and engagement with key stakeholders, government bodies, and industry 
                leaders to understand needs, expectations and regulatory landscape.
              </p>
            </div>
          </div>

          <div className="service-item left">
            <div className="service-content">
              <h3>Sustainability & Impact Potential</h3>
              <p>
                Assessment of long-term viability, environmental and social impact potential, and alignment 
                with regulatory and sustainability standards.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 12.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 10c-2.7 0-5.1-1.23-6.71-3.15.17-.67.65-1.27 1.3-1.57 1.06-.6 2.28-.99 3.41-.99s2.35.39 3.41.99c.65.3 1.13.9 1.3 1.57-1.61 1.92-4.01 3.15-6.71 3.15zm5.5-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" opacity=".2"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 12.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 10c-2.7 0-5.1-1.23-6.71-3.15.17-.67.65-1.27 1.3-1.57 1.06-.6 2.28-.99 3.41-.99s2.35.39 3.41.99c.65.3 1.13.9 1.3 1.57-1.61 1.92-4.01 3.15-6.71 3.15zm5.5-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
              </svg>
            </div>
          </div>
        </div>
      </section>

      <section className="research-process">
        <h2>Our Research Approach</h2>
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <h4>Discovery & Scoping</h4>
            <p>Understand your objectives, constraints and timeline</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h4>Research Design</h4>
            <p>Develop research methodology and data collection plan</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h4>Data Collection</h4>
            <p>Primary and secondary research with stakeholders</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h4>Analysis & Synthesis</h4>
            <p>Comprehensive analysis using proven frameworks</p>
          </div>
          <div className="step">
            <div className="step-number">5</div>
            <h4>Reporting & Recommendations</h4>
            <p>Professional report with actionable recommendations</p>
          </div>
          <div className="step">
            <div className="step-number">6</div>
            <h4>Implementation Support</h4>
            <p>Guidance on next steps and strategy execution</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to De-Risk Your Project?</h2>
        <p>Let's start with a market assessment to ensure your project is built on solid ground.</p>
        <Link to="/contact" className="cta-button">Get Started Today</Link>
      </section>
    </div>
  );
}
